export var MemberRoleEnum;
(function (MemberRoleEnum) {
    MemberRoleEnum["ADMIN"] = "admin";
    MemberRoleEnum["MEMBER"] = "member";
})(MemberRoleEnum || (MemberRoleEnum = {}));
